import { takeLatest } from 'redux-saga/effects';

import { BUY_PACKAGE } from '../../actions/buyPackage';
import { buyPackage } from './buyPackage';

export function* buyPackageSagas() {
  yield takeLatest([BUY_PACKAGE], buyPackage);
}
